"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BeyondTheMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222783" id="votre-passerelle-logistique-vers-lafrique-your-logistics-gateway" className="dark bg-background text-foreground relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/quantum_travel_hero_bg.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/20" />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-default text-6xl md:text-7xl lg:text-8xl font-extrabold text-primary drop-shadow-lg mb-6 tracking-tight">
          Votre Passerelle Logistique vers l'Afrique.
        </h1>
        
        <p className="font-default italic text-lg md:text-2xl text-foreground/70 mb-12 max-w-2xl font-light">Expertise en transit, fret et logistique internationale au cœur de l'Afrique de l'Ouest.</p>

        <Link to="#">
          <Button size="lg" className="text-lg px-10 py-7 rounded-full shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90">
            Nos Services / Our Services
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-pulse">
        <span className="font-default text-[10px] uppercase tracking-widest text-foreground/60">
          Explorer / Explore
        </span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-foreground/60 to-transparent" />
      </div>
    </section>;
}